export const RQ_GET_DML_DOCUMENT_STATUS_API = {
  url: 'doctor/dml-document-count-by-classification/<%= divisionId %>',
  method: 'GET',
  auth: true,
};
